// BigQuery のリストを取得する際にかけるディレイ(ms)
export const BqListDelayTime = 2000;
